import { useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import StatsImpact from './components/StatsImpact';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useSEO } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kgmdanismanlik.com';

  useSEO({
    title: 'KGM Danışmanlık | Sanayi, İhracat ve Kalite Süreçlerinin Tek Çözüm Ortağı | Konya',
    description: 'KGM Danışmanlık: Fabrika kurulumundan ihracat belgelerine (CE, EAC, SABER), devlet teşviklerinden dijital dönüşüm yazılımlarına kadar işletmenizin tüm ihtiyaçları tek çatı altında. ISO belgelendirme, TÜRKAK akrediteli kalibrasyon, kapasite raporu, yatırım danışmanlığı ve özel yazılım çözümleri. Konya\'da endüstriyel çözüm merkezi.',
    keywords: 'KGM Danışmanlık, ISO belgelendirme, TÜRKAK kalibrasyon, CE belgesi, EAC sertifikası, SABER belgesi, kapasite raporu, yatırım danışmanlığı, yazılım çözümleri, Konya danışmanlık, ISO 9001, ISO 14001, ISO 45001, ISO 22000, FSSC 22000',
    canonical: '/',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      name: 'KGM Danışmanlık',
      description: 'Sanayi, ihracat ve kalite süreçlerinin tek çözüm ortağı. ISO belgelendirme, TÜRKAK akrediteli kalibrasyon, CE/EAC/SABER belgelendirme, yatırım danışmanlığı ve yazılım çözümleri.',
      url: siteUrl,
      telephone: '+905543791632',
      email: 'kgmdanismanlik@gmail.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Konya',
        addressCountry: 'TR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '37.8746',
        longitude: '32.4932',
      },
      areaServed: 'TR',
      serviceType: [
        'ISO Belgelendirme',
        'Kalibrasyon Hizmetleri',
        'Ürün Belgelendirme',
        'Yatırım Danışmanlığı',
        'Yazılım Çözümleri',
        'CE İşareti',
        'EAC Sertifikası',
        'SABER Belgesi',
      ],
      priceRange: '$$',
      openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Services />
      <About />
      <WhyUs />
      <StatsImpact />
      <Contact />
      <Footer />
    </div>
  );
}
